import { get, post } from '@/utils/http'

const SYSTEM_NAME = 'carusg'

export const getNewTop = lang => post<{ data: any }>(`/news_top`)({ lang }).then(res => res.data)

export const getNews = lang => post<{ data: any }>(`/news/${lang}`)({ span: 3 }).then(res => res.data)

export const getProductTree = lang => post<{ data: any }>(`/product_tree/${lang}`)()

/**
 * 咨询（contact us）提交表单
 */
export const formSubmit = data => post(`/post/visitor/submit`)(data)

/**
 * 上报用户访问（pv、uv）事件
 */
export const submitVisitEvent = params => post(`/post/stat/visit`)({ system: SYSTEM_NAME, ...params })

/**
 * 获取访问（pv、uv）统计图表数据
 */
export const getVisitCharts = params => post(`/post/stat/info/get`)({ system: SYSTEM_NAME, ...params })
